import classNames from 'classnames'
import React from 'react'
import { WemoloLoading } from '../Wemolo'
import styles from './OverlaySpinner.module.css'

export const OverlaySpinner = ({
    children,
    loading = true,
    loadingTop = false
}: {
    children: React.ReactNode
    loading?: boolean
    loadingTop?: boolean
}) => {
    return (
        <div className={styles.wrapper}>
            {children}
            {loading && (
                <div className={classNames(styles.overlay, loadingTop && styles.top)}>
                    <div className={classNames(styles.inner, loadingTop && styles.top)}>
                        <WemoloLoading />
                    </div>
                </div>
            )}
        </div>
    )
}
